module.exports = __webpack_public_path__ + "img/dryva-user-persona.9f708627.png";